module.exports = __webpack_public_path__ + "img/4.ce83ba03.jpg";